
import { jwordColorList,jwordFontList,jwordFontSizeList,jwordStyleList } from "./jword-config";
import { ChunkedBufferSender} from './ChunkedBufferSender';

var $ = require("jquery");

var JWRVERSION="4.1.15.12";
//JWord editor pane
export default class JWORD{	
	constructor(websockurl,weburl,element,options,oninit,onfocus) {
		this.charListeners=[];
		this.paraListeners=[];
		this.allImages=[];
		this.imageMap = new Map();
		this.jmeMenuAction = this.jmeMenuAction.bind(this);
		this.jmeGenerateMenuHtml = this.jmeGenerateMenuHtml.bind(this);
		this.jmeOpenMenu = this.jmeOpenMenu.bind(this);
		this.options = options;
		this.oninit = oninit;
		this.onfocus = onfocus;
		this.jwrId = element;
		this.rootElem = document.getElementById(element);
		this.websockurl = this.convertUrl(websockurl,true);//"ws:"+url+"/jword4";
		this.weburl = this.convertUrl(weburl,false);//"http:"+url;
		this.jmeInit();		
		//if(this.options.lang!=null)
		//	jwordSetLanguage(this,this.options.lang);
	}
	convertUrl(url,isws)
	{
		if(url.substring(0,1) === '/')
		{
			var loc = window.location, new_uri;
			if(isws)
			{
				if (loc.protocol === "https:") {
				    new_uri = "wss:";
				} else {
				    new_uri = "ws:";
				}				
			}
			else
				new_uri = loc.protocol;
			new_uri += "//" + loc.host;
			new_uri += url;
			return new_uri;			
		}
		return url;
	}
	jmeInitClipboard()
	{
		this.svgDiv.addEventListener('paste', (event) => {

			//console.log(event.clipboardData);
			//console.log(event.clipboardData.types);

		    let paste = (event.clipboardData || window.clipboardData).getData('text/rtf');
		    if(paste != null && paste != '')
		   	{
			    //console.log(paste);
			    this.insertRTF(paste);			
			}
			else
			{
		    	paste = (event.clipboardData || window.clipboardData).getData('text/plain');
			    this.insertText(paste);							
			}
		    //console.log(paste);
		    event.preventDefault();
		});		
		this.svgDiv.addEventListener('focus', (event) => {
			if(this.onfocus != undefined)
				this.onfocus(this.jwrId);
			console.log("FOCUS!! "+this.jwrId);
		});
		this.svgDiv.addEventListener('blur', (event) => {
			//console.log("BLUR!!");
			this.jmeFocusOut();
		});
		
	}
	jmeInit()
	{
		this.toolbar = document.createElement("div");
		this.menu = document.createElement("div");
		this.svgDiv = document.createElement("div");
		
		this.prevMouseDown = 0;
		this.prevMouseUp = 0;
		
		$(this.menu).attr("id","jwordMenu");
		$(this.menu).toggleClass("jmeToolbar");

		$(this.toolbar).attr("id",this.rootElem.id+"-jwordToolbar");
		$(this.toolbar).toggleClass("jmeToolbar");
		
		this.svgDiv.tabIndex="-1";
		this.svgDiv.classList.add("jmeContent");
		this.svgDiv.style.cursor = 'text';
		$(this.svgDiv).attr("id","svgDiv");
		$(this.svgDiv).attr("contenteditable","true");
		window.onclick = this.jmeShowHideDropdowns.bind(this);
		this.svgDiv.onkeydown = this.jmeOnContentKeyDown.bind(this); 
		//this.svgDiv.ondblclick = this.jmeOnContentDoubleClick.bind(this);
		//this.svgDiv.onclick = this.jmeOnContentClick.bind(this);		
		this.svgDiv.onmousedown = this.jmeOnContentMouseDown.bind(this);
		this.svgDiv.onmousemove = this.jmeOnContentMouseMove.bind(this);
		this.svgDiv.onmouseup = this.jmeOnContentMouseUp.bind(this);
		
		$(this.svgDiv).resize(function(){
			var w = $(this.svgDiv).width()-50;
			var h = $(this.svgDiv).height();
			this.jwordMenuAction('resize',{'viewWidth':w,'viewHeight':h});
		});
		this.rootElem.appendChild(this.menu);
		this.rootElem.appendChild(this.toolbar);
		this.rootElem.appendChild(this.svgDiv);

		var that=this;

		this.jmeInitClipboard();				
		this.jmeFocus();
		this.jmeOpenSocket();				  
		this.inTable = false;
	}
	jmeCheckInitStatus()
	{
		if(this.menuLoaded==undefined || !this.menuLoaded)
			return;
		if(this.toolbarLoaded==undefined || !this.toolbarLoaded)
			return;
		if(this.socketOpen==undefined || !this.socketOpen)
			return;
		if(this.oninit!=undefined)
			this.oninit(this.jwrId);		
		//$(this.svgDiv).attr("contenteditable","false");		
	}
	jmeAddCharListener(listener)
	{
		this.charListeners.push(listener);
	}
	jmeAddParaListener(listener)
	{
		this.paraListeners.push(listener);
	}
	//open web socket and register handlers
	jmeOpenSocket()
	{
		this.jmeWebSocket = new WebSocket(this.websockurl);
		this.jmeWebSocket.jwrId = this.jwrId;
		if ( this.jmeWebSocket.readyState === 3 )
		{
			this.jmeWebSocket.close();
			this.jmeWebSocket = new WebSocket(this.websockurl);
		}		
		this.jmeWebSocket.onopen = this.jmeSocketOpen.bind(this);
		this.jmeWebSocket.onmessage = this.jmeSocketGetMessage.bind(this);
		
		this.jmeWebSocket.onclose = this.jmeSocketClose.bind(this);
		this.jmeWebSocket.onerror = this.jmeSocketError.bind(this);
	}
	jwordSend(obj)
	{
		var jsonString = JSON.stringify(obj);
		//console.log('SOCKET:'+this.jmeWebSocket.jwrId + " "+jsonString);
		this.jmeWebSocket.send(jsonString);		
	}
	jmeGetJwordSvg()
	{
		return $(this.svgDiv).find('.jwordSvg').get(0);//document.getElementById("jwordSvg");
	}
	jmeGetCursor(svg)
	{
		return $(svg).find("rect[id='jmeCursor']").get(0);//svg.getElementById("jmeCursor");
	}
	jmeFocus()
	{
		//var that=this.svgDiv;
		//setTimeout(function(){
        //   that.focus(); 
        //}, 1);
		this.svgDiv.focus(); 
		var svg = this.jmeGetJwordSvg();
		if(svg!=null)
		{
		    var cursor = this.jmeGetCursor(svg);
			
		    if(cursor!=null)
		    	cursor.style.fill="#000066";	
		    this.jmeShowHideDropdowns();			
		}
	}
	jmeOnContentKeyDown(event)
	{
		var json = {command: 'KEY',key: event.key,keyCode: event.keyCode,altKey: event.altKey,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey};
		//this.jmeWebSocket.send("KEY;"+event.key+";"+event.keyCode+";"+event.altKey+";"+event.ctrlKey+";"+event.shiftKey+";false;");
		if(event.key=='f' && event.ctrlKey)
		{//	jmeOpenFindReplaceDialog(this);
		}
		else if(event.key=='v' && event.ctrlKey)
			return;
		else
			this.jwordSend(json);
		event.stopPropagation();
		event.preventDefault();
		this.jmeFocus();
	}
	jmeOnContentClick(event)
	{
		 event = event || window.event;

		  var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left + target.scrollLeft),
		    offsetY = Math.round(event.clientY - rect.top + target.scrollTop);

		 //console.log('CLICK'+[offsetX, offsetY]);		
		 //var json={command: 'CLICK',offsetX: offsetX,offsetY: offsetY,altKey: event.altKey,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey};
		 //this.jwordSend(json);
		 //this.jmeFocus();
	}
	jmeOnContentMouseDown(event)
	{
		 event = event || window.event;
		 this.prevMouseDown = event.timeStamp;
		 //console.log('prevMouseDown'+this.prevMouseDown);		
		 event.preventDefault();
		 var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left + target.scrollLeft),
		    offsetY = Math.round(event.clientY - rect.top + target.scrollTop);

		 //console.log('MOUSEDOWN'+[offsetX, offsetY]);		
		 var json={command: 'MOUSE',offsetX: offsetX,offsetY: offsetY,altKey: event.altKey,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey};
		 this.jwordSend(json);
		 this.jmeFocus();
		 event.stopPropagation();
	}
	jmeOnContentDoubleClick(event)
	{
		 event = event || window.event;

		  var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left + target.scrollLeft),
		    offsetY = Math.round(event.clientY - rect.top + target.scrollTop);
		 
		 this.prevMouseUp=0;
		 this.prevMouseDown=0;
		 
		 //console.log('DOUBLE-CLICK'+[offsetX, offsetY]);		

		 if(this.charProps.hasEquation)
		 {
			 this.getEquation(function(data){
				if(this.equationCallback)
					this.equationCallback(data);
				 //jmeOpenEquationDialog(this,data);
			 });
			 return;
		 }
		 var json={command: 'DBLCLICK',offsetX: offsetX,offsetY: offsetY,altKey: event.altKey,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey};
		 this.jwordSend(json);
		 //this.jmeWebSocket.send("CLICK;"+offsetX+";"+offsetY+";"+event.altKey+";"+event.ctrlKey+";"+event.shiftKey+";");
		 this.jmeFocus();
	}	
	jmeOnContentMouseMove(event)
	{
		 event = event || window.event;
		 if(event.buttons!=1)
			 return;
		  var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left + target.scrollLeft),
		    offsetY = Math.round(event.clientY - rect.top + target.scrollTop);

		 //console.log("mouse move:"+event.buttons+([offsetX, offsetY]));			 
		 event.stopPropagation();
		 event.preventDefault();
		 var json={command: 'MOUSEMOVE',offsetX: offsetX,offsetY: offsetY};
		 this.jwordSend(json);
		 //this.jmeWebSocket.send("MOUSE;"+offsetX+";"+offsetY+";");
		 //jmeWebSocket.send("CLICK;"+offsetX+";"+offsetY+";");
		 //jmeFocus();
	}
	jmeOnContentMouseUp(event)
	{
		 event = event || window.event;

		 var timeVal = event.timeStamp;
		 //console.log('TIME:'+(timeVal-this.prevMouseUp)+" "+timeVal);					 
		 if(timeVal-this.prevMouseUp<300 && timeVal-this.prevMouseDown<500) //50 ms, 100 ms
		 {
			 //console.log('CALL DCLICK'+[offsetX, offsetY]);					 
			 this.jmeOnContentDoubleClick(event);
			 return;
		 }
		 this.prevMouseUp=event.timeStamp;
		 //console.log('prevMouseUp'+this.prevMouseUp);				 
		 var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left + target.scrollLeft),
		    offsetY = Math.round(event.clientY - rect.top + target.scrollTop);

		 //console.log('MOUSEUP'+[offsetX, offsetY]);		
		 var json={command: 'MOUSEUP',offsetX: offsetX,offsetY: offsetY,altKey: event.altKey,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey};
		 this.jwordSend(json);
		 //this.jmeFocus();
	}
	// Close the dropdown if the user clicks outside of it
	jmeShowHideDropdowns(event)
	{
	    var dropdowns = document.getElementsByClassName("jmeDropdown-content");
	    var i;
	    var trg;
	    if(event != undefined)
	    	trg = $(event.target);
	    for (i = 0; i < dropdowns.length; i++) {
	      var openDropdown = dropdowns[i];
	      var btn = $('#'+openDropdown.id+'-btn');
	      if(trg == undefined || (trg.parents('#'+openDropdown.id+'-btn').length==0 && !trg.is(btn)))
	      {
	    	  if (openDropdown.classList.contains('jmeShowMenu')) {
	    		  openDropdown.classList.remove('jmeShowMenu');
	    	  }
	      }
	    }
	}
	jwordHandleSize(size)
	{
		var svg = this.jmeGetJwordSvg();
	    svg.setAttribute("width",size.width);
	    svg.setAttribute("height",size.height);
	    svg.setAttribute("viewBox","0 0 "+size.viewWidth+" "+size.viewHeight);
	}
	jwordHandleChanges(changes)
	{
		var svg = this.jmeGetJwordSvg();
		if(svg == undefined)
		{
			console.log("SVG undefined!!");
			return;
		}
		for(var i = 0; i < changes.length; i++) {
		    var view = changes[i];
		    var grp = svg.getElementById(view.id);
		    var grpContent;
		    if(grp == undefined)
		    {
		    	grp = document.createElementNS("http://www.w3.org/2000/svg", "g");
		    	grp.setAttribute("id",view.id);
		    	grpContent = document.createElementNS("http://www.w3.org/2000/svg", "g");
		    	grpContent.setAttribute('id',view.id+'_C');
		    	grp.appendChild(grpContent);
		    	var prnt = svg;
		    	if(view.parentid != undefined && view.parentid>'')
		    		prnt = svg.getElementById(view.parentid);
		    	var sibling = undefined;
		    	if(prnt.children.length>view.order)
		    		sibling = prnt.children[view.order>0?view.order:1];
		    	if(sibling != undefined)
		    	{
		    		//console.log('sibling:'+sibling+' view:'+view.id+' '+view.name);
		    		prnt.insertBefore(grp,sibling);
		    	}
		    	else
		    		prnt.appendChild(grp);
		    }
		    else
		    	grpContent = svg.getElementById(view.id+'_C');
		    grp.setAttribute("transform","translate("+view.x+","+view.y+")");
		    grpContent.innerHTML = view.code;

		    //console.log("change: "+view.code);
		}		    	
	}
	jwordHandleRemoves(removes)
	{
		var svg = this.jmeGetJwordSvg();
		for(var i = 0; i < removes.length; i++) {
		    var view = removes[i];
		    var grp = svg.getElementById(view.id);
		    if(grp != undefined)
			    grp.remove();
		    //console.log("remove: "+view.id);
		}		    	
	}
	jwordHandleImage(image)
	{
		var svg = this.jmeGetJwordSvg();
		for(var i=0;i<this.allImages.length;i++)
		{
			if(this.allImages[i].imageId == image.imageId)
			{
				this.allImages[i].data = image.data;
				this.allImages[i].imageType = image.imageType;
			    var imgElement = svg.getElementById("img_"+this.allImages[i].imageId);
				//imgElement.setAttribute("href",'data:image/png;base64,'+this.allImages[i].data);
			    if(imgElement!=null)
			    	imgElement.setAttribute("href",'data:image/'+image.imageType+';base64,'+this.allImages[i].data);				
			}
		}
	}
	jwordHandleTextStyles(textStyles)
	{
		var svg = this.jmeGetJwordSvg();
	    var style = svg.getElementsByTagName("style")[0];
	    style.innerHTML = style.innerHTML + textStyles;
	}
	jwordHandleImages(images)
	{
		for(var i=0;i<images.length;i++)
		{
			if(this.imageMap.has(images[i].imageId)==false)
			{
				this.allImages.push(images[i]);
				this.imageMap.set(images[i].imageId,images[i]);
				this.getImage(images[i].imageId);
			}
		}
		for(var i=0;i<this.allImages.length;i++)
		{
			var svg = this.jmeGetJwordSvg();
		    var imgElement = svg.getElementById("img_"+this.allImages[i].imageId);
			
		    if(imgElement!=null)
		    {
		    	if(imgElement.getAttribute("href")==null)
		    		imgElement.setAttribute("href",'data:image/'+this.allImages[i].imageType+';base64,'+this.allImages[i].data);			    	
		    }
		    	//imgElement.setAttribute("href",this.weburl+'/rest/file/image/'+this.allImages[i].fileId);
		}	
	}
	jwordHandleMoves(moves)
	{
		var svg = this.jmeGetJwordSvg();
		for(var i = 0; i < moves.length; i++) {
		    var view = moves[i];
		    var grp = svg.getElementById(view.id);
		    if(grp != undefined)
		    {
			    grp.setAttribute("transform","translate("+view.x+","+view.y+")");
			    var prnt = svg.getElementById(view.parentid);			    
			    if(prnt !=null)
			    {
			    	var sibling = undefined;
			    	if(prnt.children.length>view.order)
			    		sibling = prnt.children[view.order>0?view.order:1];
			    	if(sibling != undefined)
			    	{
			    		//console.log('sibling:'+sibling+' view:'+view.id+' '+view.name);
			    		prnt.insertBefore(grp,sibling);
			    	}
			    	else
			    		prnt.appendChild(grp);
			    }
		    }
		    //console.log("move: "+view.id+" x="+view.x+" y="+view.y);
		}		    	
	}
	jwordHandleCursor(cursor)
	{
		var svg = this.jmeGetJwordSvg();
	    var crs = this.jmeGetCursor(svg);
		
	    if(crs!=null)
	    {
		    var anim = crs.getElementsByTagName('animate')[0];

	    	crs.setAttribute("x",cursor.x);
	    	crs.setAttribute("y",cursor.y);
	    	crs.setAttribute("width","30");//cursor.width
	    	crs.setAttribute("height",cursor.height);
		    crs.style.fill="#000066";	
		    crs.remove();
		    svg.appendChild(crs);
		    
		    anim.beginElement();//restart anim
	    }
	}
	createLine(x1,y1,x2,y2,stroke,strokeWidth)
	{
    	var rect = document.createElementNS("http://www.w3.org/2000/svg", "line");
    	$(rect).attr("x1",x1);
    	$(rect).attr("y1",y1);
    	$(rect).attr("x2",x2);
    	$(rect).attr("y2",y2);
    	$(rect).css("stroke-width",strokeWidth);	    	
    	$(rect).css("stroke",stroke);
    	return rect;
	}
	createBox(x,y,width,height,fill,stroke,strokeWidth,cursor)
	{
    	var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    	$(rect).attr("x",x);
    	$(rect).attr("y",y);
    	$(rect).attr("width",width);
    	$(rect).attr("height",height);
    	$(rect).css("fill",fill);
    	$(rect).css("stroke-width",strokeWidth);	    	
    	$(rect).css("stroke",stroke);
		if(cursor != undefined)
			$(rect).css("cursor",cursor);
    	return rect;
	}
	jwordHandleSelectedObject(sel)
	{
		var svg = this.jmeGetJwordSvg();
	    var crs = svg.getElementById(sel.viewId+'_C');
	    var oldSel = svg.getElementById('jwordSelectedObject');
	    var oldDragBorder = svg.getElementById('jwordDragBorder');
		
	    if(oldSel!=null)
	    	$(oldSel).remove();
	    if(oldDragBorder!=null)
	    	$(oldDragBorder).remove();
		$(svg).css("cursor","text");
		if(crs!=null)
	    {
	    	var selGrp = document.createElementNS("http://www.w3.org/2000/svg", "g");
	    	$(selGrp).attr("id","jwordSelectedObject");	    		    	
	    	var rect = this.createBox(sel.x,sel.y,sel.width,sel.height,"none","black",20);
		    $(selGrp).append(rect);
		    for(var i=0;i<sel.handles.length;i++)
		    {
		    	var handle=sel.handles[i];
		    	var handleBox = this.createBox(handle.x-50,handle.y-50,100,100,"white","blue",10,"pointer");
			    $(selGrp).append(handleBox);		    	
		    }
		    $(crs).append(selGrp);
		    if(sel.dragRect != undefined)
		    {
		    	var dragBox = this.createBox(sel.dragRect.x,sel.dragRect.y,sel.dragRect.width,sel.dragRect.height,
		    			"none","rgb(50,50,50)",10);
		    	 $(selGrp).append(dragBox);
				 $(svg).css("cursor","pointer");
		    }
			else
				$(svg).css("cursor","text");
	    }
		if(sel.dragBorder != undefined)
		{
		    var dragLine = this.createLine(sel.dragBorder.pos,0,sel.dragBorder.pos,10000,"rgb(150,150,150)",20);
			$(dragLine).attr("id","jwordDragBorder");
			$(svg).append(dragLine);
			$(svg).css("cursor","col-resize");
		}
	}

	jmeSocketGetMessage(message) {
		var jsonObj = JSON.parse(message.data);
		if(jsonObj.echo != undefined)
		{
			var d = new Date();
			this.echoTime = d.getTime() - this.echoTime;
			//console.log("echo duration: "+this.echoTime);
			this.echoCallback(this.echoTime);
			return;
		}
		if(jsonObj.svg != undefined)
			this.svgDiv.innerHTML = '<div style="height:0;overflow: hidden;">jword</div>'+jsonObj.svg; //Chrome bug that does not paste into empty doc by ctrl-v
		if(jsonObj.changed != undefined)
			this.jwordHandleChanges(jsonObj.changed);
		if(jsonObj.moved != undefined)
			this.jwordHandleMoves(jsonObj.moved);
		if(jsonObj.removed != undefined)
			this.jwordHandleRemoves(jsonObj.removed);
		if(jsonObj.cursor != undefined)
			this.jwordHandleCursor(jsonObj.cursor);
		if(jsonObj.selectedObject != undefined)
			this.jwordHandleSelectedObject(jsonObj.selectedObject);		
		if(jsonObj.textStyles != undefined)
			this.jwordHandleTextStyles(jsonObj.textStyles);
		if(jsonObj.images != undefined)
			this.jwordHandleImages(jsonObj.images);
		if(jsonObj.pageSettings != undefined)
		{
			this.pageSettings = jsonObj.pageSettings;
			if(this.pageSettingsCallback != undefined)
				this.pageSettingsCallback(jsonObj.pageSettings);
		}
		if(jsonObj.bookmark != undefined)
		{
			if(this.bookmarkCallback != undefined)
				this.bookmarkCallback(jsonObj.bookmark);
		}
		if(jsonObj.document != undefined)
		{
			if(this.documentCallback != undefined)
				this.documentCallback(jsonObj.document);
		}
		if(jsonObj.pictureSettings != undefined)
		{
			this.pictureSettings = jsonObj.pictureSettings;
			if(this.pictureSettingsCallback != undefined)
				this.pictureSettingsCallback(jsonObj.pictureSettings);
		}
		if(jsonObj.fields != undefined)
		{
			if(this.getFieldsCallback != undefined)
				this.getFieldsCallback(jsonObj.fields);
		}
		if(jsonObj.mediaLinks != undefined)
		{
			if(this.getMediaLinksCallback != undefined)
				this.getMediaLinksCallback(jsonObj.mediaLinks);
		}	
		if(jsonObj.equation != undefined)
		{
			if(this.equationDataCallback != undefined)
				this.equationDataCallback(jsonObj.equation);
		}
		if(jsonObj.openField != undefined)
		{
			if(this.openFieldCallback != undefined)
				this.openFieldCallback(jsonObj.openField);
		}	
		if(jsonObj.tableProps != undefined)
		{
			this.tableProps = jsonObj.tableProps;
			if(this.tablePropsCallback != undefined)
				this.tablePropsCallback(jsonObj.tableProps);
		}
		if(jsonObj.size != undefined)
			this.jwordHandleSize(jsonObj.size);		

		if(jsonObj.charProps != null)
			this.jmeCharPropsChanged(jsonObj.charProps)
		if(jsonObj.paraProps != null)
			this.jmeParaPropsChanged(jsonObj.paraProps)
		if(jsonObj.image != null)
			this.jwordHandleImage(jsonObj.image);		
		//GSS REACT
		if(jsonObj.modified != null && jsonObj.modified == true && (this.modifiedCallback != undefined))
			this.modifiedCallback();		
		if(jsonObj.documentSaved != null)
		{
			this.sessionId = jsonObj.documentSaved.sessionId;
			if(this.saveCallback)
				this.saveCallback(jsonObj.documentSaved);
		}	
	}
	jmeCharPropsChanged(cp)
	{
		var changed=false;
		//console.log("CharProps:hasEquation:"+cp.hasEquation);
		
		if(this.charProps != undefined)
		{
			if(cp.bold != this.charProps.bold)
				changed = true;
			if(cp.italic != this.charProps.italic)
				changed = true;
			if(cp.uline != this.charProps.uline)
				changed = true;			
			if(cp.sub != this.charProps.sub)
				changed = true;			
			if(cp.super != this.charProps.super)
				changed = true;			
			if(cp.face != this.charProps.face)
				changed = true;			
			if(cp.size != this.charProps.size)
				changed = true;		
			if(cp.style != this.charProps.style)
				changed = true;					
			if(cp.hasImage != this.charProps.hasImage)
				changed = true;					
			if(cp.hasEquation != this.charProps.hasEquation)
				changed = true;					
			if(cp.inTable != this.charProps.inTable)
				changed = true;					
			if(cp.color != this.charProps.color)
				changed = true;					
			if(cp.backColor != this.charProps.backColor)
				changed = true;					
		}
		else
			changed=true;
		this.charProps = cp;
		if(changed)
		{
			for(var i=0;i<this.charListeners.length;i++)
				this.charListeners[i](this.charProps);					
		}
	}
	jmeParaPropsChanged(pp)
	{
		var changed=false;
		if(this.paraProps != undefined)
		{
			if(pp.align != this.paraProps.align)
				changed = true;
		}
		else
			changed=true;
		this.paraProps = pp;
		if(changed)
		{
			for(var i=0;i<this.paraListeners.length;i++)
				this.paraListeners[i](this.paraProps);					
		}
	}	
	jmeEcho(callback)
	{
		var d = new Date();
		this.echoTime = d.getTime();
		//console.log("echo start: "+this.echoTime);
		this.echoCallback = callback;
		var cmd={commads: 'ECHO', msg: 'Hello_JWord_v4'};
		this.jmeWebSocket.send(JSON.stringify(cmd));
	}
	jmeSocketOpen(message) {
		//console.log("Connected ... \n");
		var w = $(this.svgDiv).width()-50;
		var h = $(this.svgDiv).height();
		this.options.viewWidth=w;
		this.options.viewHeight=h;		
		this.jwordMenuAction("init",this.options);
		this.socketOpen = true;
		this.jmeCheckInitStatus();
	}

	jmeMenuAction(action)
	{
		//this.jmeWebSocket.send("MENU;"+command+";");
		var cmd = {command: 'MENU',action: action};
		this.jwordSend(cmd);
		this.jmeFocus();
		this.jmeShowHideDropdowns();	
	}
	jwordMenuAction(action,params)
	{
		//this.jmeWebSocket.send("MENU;"+command+";");
		var cmd = {command: 'MENU',action: action, params: params};
		this.jwordSend(cmd);
		this.jmeFocus();
		//this.jmeShowHideDropdowns();	
	}
	jmeFocusOut(){
		var svg = this.jmeGetJwordSvg();
	    var cursor = this.jmeGetCursor(svg);
	    if(cursor!=null)
	    	cursor.style.fill="none";
	};

	jmeCloseConnection() {
		this.jmeWebSocket.close();
	}

	jmeSocketClose(message) {
		console.log("Disconnect ... : "+message+"\n");
	}

	jmeSocketError(message) {
		console.log("Error ... "+message+"\n");
	}
	jmeGenerateMenuHtml(menu,prnt)
	{
		var that = this;
		let cls="icon";
		if(menu.menu=='function')
			cls="iconf";
		menu.items.forEach(function(entry) {
			var mi = document.createElement("a");
			mi.href="#";
			mi.style.backgroundPosition = '-'+entry.x+'px -'+entry.y+'px';
			mi.classList.add(cls);
			mi.onclick = function(){that.jmeMenuAction(entry.name)};
			prnt.appendChild(mi);
		});
	}
	jwordAddCreateTableButton()
	{
		var that=this;
		var props={rows: 5, cols: 2};
		this.jmeAddToolbarButton(that.toolBar,function(){that.jwordMenuAction('table_add',props)},"TABLE");			
	}
	jmeAddButton(prnt,onclick,txt)
	{
		var mi = document.createElement("a");
		mi.classList.add("jmeListItem");
		mi.href="#";
		mi.onclick = onclick;
		mi.text = txt;
		prnt.appendChild(mi);
	}
	jmeAddToolbarButton(prnt,onclick,txt)
	{
		var mi = document.createElement("button");
		mi.classList.add("jmeDropdownBtn");
		mi.onclick = onclick;
		mi.classList.add('jmeNoIcon');
		mi.innerHTML = txt;
		prnt.appendChild(mi);
	}	
	jmeGenerateColorMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jmeDropdown');
		let btn = document.createElement("button");
		btn.classList.add('jmeDropdownBtn');
		btn.classList.add('jmeNoIcon');
		btn.style.color="#000";
		btn.style.fontSize="20px";
		btn.innerHTML="&#9724;";
		btn.id = that.rootElem.id+"-color-btn";
		btn.onclick = function(){that.jmeOpenMenu(that.rootElem.id+'-color')};
		let con = document.createElement("div");
		con.classList.add('jmeDropdown-content');
		con.id = that.rootElem.id+'-color';

		var cv = [ '00', '56', 'aa', 'ff' ];
		for (var r = 0; r < 4; r++)
			for (var g = 0; g < 4; g++)
				for (var b = 0; b < 4; b++)
				{
					let cl=cv[r]+cv[g]+cv[b];
					var mi = document.createElement("a");
					mi.classList.add("colorIcon");
					mi.onclick = function(){that.jmeMenuAction('color'+cl)};
					mi.innerHTML = '<div style="width:16px;height:16px;background:#'+cl+'"></div>';
					con.appendChild(mi);
				}
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);		
	}			
	/*jmeOpenMenu(menuName)
	{
		var mn = document.getElementById(menuName);
		mn.classList.toggle("jmeShowMenu");

		var parentRect = this.toolBar.getBoundingClientRect();
		var rect = mn.getBoundingClientRect();
		if(rect.x + rect.width>parentRect.x+parentRect.width)
		{
			mn.style.left = ""+-(rect.x + rect.width -parentRect.x - parentRect.width )+"px";
			console.log("EXCEEDS!!");
		}
	}*/
	jmeOpenMenu(prnt,menuName)
	{
		var mn = $(prnt).find('#'+menuName).get(0);
		mn.classList.toggle("jmeShowMenu");

		var parentRect = this.toolbar.getBoundingClientRect();
		var rect = mn.getBoundingClientRect();
		if(rect.x + rect.width>parentRect.x+parentRect.width)
		{
			mn.style.left = ""+-(rect.x + rect.width -parentRect.x - parentRect.width )+"px";
			console.log("EXCEEDS!!");
		}
	}

	insertTable(rows,cols)
	{
		var props={'rows':rows,'cols':cols};
		this.jwordMenuAction('insertTable',props);
	}
	insertTableAdvanced(rows,cols,inset,border,backColor,tableWidth,columnWidths,data)
	{
		var props={'rows':rows,'cols':cols,'inset':inset,'border':border,'backColor':backColor,'tableWidth':tableWidth,'columnWidths':columnWidths,'data':data};
		this.jwordMenuAction('insertTableAdvanced',props);
	}

	insertRow()
	{
		this.jmeMenuAction('table_insertRow');
	}
	insertColumn()
	{
		this.jmeMenuAction('table_insertColumn');
	}
	deleteRow()
	{
		this.jmeMenuAction('table_deleteRow');
	}
	deleteColumn()
	{
		this.jmeMenuAction('table_deleteColumn');
	}
	getPageSettings(callback)
	{
		this.pageSettingsCallback = callback;
		this.jmeMenuAction("getPageSettings");
	}
	getDocument(docType,callback)
	{
		this.documentCallback = callback;
		this.jwordMenuAction("getDocument",{'docType':docType});
	}
	getImage(id)
	{
		this.jwordMenuAction("getImage",{'id':id});		
	}
	setDocument(docType,data)
	{
		/*
		var dataFile={'name':'doc','imageType':docType,'data':data};
		$.ajax({
            type: "POST",
            url: jmeA.weburl+"/rest/file/uploadImage",
            data: JSON.stringify(dataFile),
            dataType: 'text',
            contentType: "application/json",
            cache: false,
            timeout: 600000,
            success: function (fileId) {
                jmeA.openDocument(docType,fileId);
            },
            error: function (e) {
                console.log("ERROR : ", e);
            }
        });		
        */
		this.jwordMenuAction("openDocument",{'docType':docType,'data':data});	
	}
	openDocument(docType,fileId)
	{
		this.jwordMenuAction("openDocument",{'docType':docType,'fileId':fileId});		
	}
	insertBookmark(name)
	{
		this.jwordMenuAction("insertBookmark",{'name':name});		
	}
	gotoBookmark(name,callback)
	{
		this.bookmarkCallback=callback;
		this.jwordMenuAction("gotoBookmark",{'name':name});		
	}	
	gotoCell(pos,row,col)
	{
		this.jwordMenuAction("gotoCell",{'pos':pos,'row':row,'col':col});				
	}
	gotoPosition(pos)
	{
		this.jwordMenuAction("gotoPosition",{'pos':pos});						
	}
	getPictureSettings(callback)
	{
		this.pictureSettingsCallback = callback;
		this.jmeMenuAction("getPictureSettings");
	}
	getFields(callback)
	{
		this.getFieldsCallback = callback;
		this.jmeMenuAction("getFields");
	}
	getMediaLinks(callback)
	{
		this.getMediaLinksCallback = callback;
		this.jmeMenuAction("getMediaLinks");
	}
	getEquation(callback)
	{
		this.equationDataCallback = callback;
		this.jmeMenuAction("getEquation");
	}
	getTableProps(callback)
	{
		this.tablePropsCallback = callback;
		this.jmeMenuAction("getTableProps");
	}
	deleteTable()
	{
		this.jmeMenuAction('table_deleteTable');
	}
	mergeCells()
	{
		this.jmeMenuAction('table_mergeCells');
	}
	splitCells()
	{
		this.jmeMenuAction('table_splitCells');
	}
	/*
	insertImage(imageId)
	{
		var props={'imageId':imageId};
		this.jwordMenuAction('insertImage',props);
	}*/
	insertImage(image)
	{
		var props={'type':image.type,'name':image.name,'autoScale':image.autoScale,'data':image.data};
		this.jwordMenuAction('insertImage',props);
	}	
	async insertImageChunked(image,buffer)
	{
    	console.log('Switching to large data mode...');
		const chunks = Math.ceil(buffer.byteLength/(64 * 1024));
		var props={'type':image.type,'name':image.name,'autoScale':image.autoScale,'chunks':chunks};
		this.jwordMenuAction('insertImageChunked',props);
    
    	this.sender = new ChunkedBufferSender(this.jmeWebSocket, 64 * 1024);
        await this.sender.send(buffer);
	}
	/*
	insertEquation(mathData,imageId,align,isnew)
	{
		var props={'imageId':imageId,'mathData': mathData,'align':align,'isnew':isnew};
		this.jwordMenuAction('insertEquation',props);
	}
	*/
	insertEquation(mathData,image,align,isnew)
	{
		var props={'type':'image/png','name':image.name,'data':image.data,'mathData': mathData,'align':align,'isnew':isnew};
		this.jwordMenuAction('insertEquation',props);
	}

	editCut()
	{
		this.jmeMenuAction('edit_cut');
	}
	editCopy()
	{
		this.jmeMenuAction('edit_copy');
	}
	editPaste()
	{
		this.jmeMenuAction('edit_paste');		
	}
	newDocument()
	{
		this.jwordMenuAction('newDocument',{});
		this.allImages=[];//clear
	}
	setCellContent(pos,row,col,text)
	{
		this.jwordMenuAction('setCellContent',{'pos':pos,'row':row,'col':col,'text':text});		
	}
	rearrangeTable(pos,columns,columnWidths)
	{
		this.jwordMenuAction('rearrangeTable',{'pos':pos,'columns':columns,'columnWidths':columnWidths});				
	}
	undo()
	{
		this.jwordMenuAction('undo',{});		
	}
	redo()
	{
		this.jwordMenuAction('redo',{});		
	}
	insertHeaderFooter()
	{
		this.jwordMenuAction('insertHeaderFooter',{});				
	}
	setViewMode(mode)
	{
		var w = $(this.svgDiv).width()-50;
		var h = $(this.svgDiv).height();
		this.jwordMenuAction('setViewMode',{'viewMode':mode,'viewWidth':w,'viewHeight':h});
	}
	zoom(ratio)
	{
		this.jwordMenuAction('zoom',{'zoom':ratio});		
	}
	setHyperLink(link)
	{
		this.jwordMenuAction('setHyperLink',{'link':link});		
	}
	setOptions(options)
	{
		this.jwordMenuAction('setOptions',options);				
	}
	indent()
	{
		this.jwordMenuAction('indent',{});				
	}
	outdent()
	{
		this.jwordMenuAction('outdent',{});						
	}
	setBullet(bullet)
	{
		this.jwordMenuAction('setBullet',{'bullet':bullet});				
	}
	setNumber(numberType)
	{
		this.jwordMenuAction('setNumber',{'number':numberType});				
	}
	insertText(text)
	{
		this.jwordMenuAction('insertText',{'text':text});		
	}
	insertRTF(text)
	{
		var rtf = btoa(text);
		this.jwordMenuAction('insertText',{'text':rtf,'rtf':true});				
	}
}
